<script>
    import axios from "axios";
    export let settings;
    export let dataapi;
    export let datanik;
    let apidata = [];
    let showform = false;
    axios
      .get(settings.url + "/sipade/lay_api/" + dataapi + "/" + datanik, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        apidata = response.data;
        showform = true;
      });
    let agemin;  
</script>

{#if showform}
<table border="0" width="100%" class="listtable layTemplate" id="SKK-layTemplate" style="display: table;">
                    <tbody>
                            {#if apidata.data.ortu.ayah}
                            <tr>
                                <td colspan="3">
                                    <b class="float-right px-2 rounded-full bg-green-500 text-white">
                                        AYAH
                                    </b>
                                    <div class="box box-widget">
                                        <div class="box-header with-border">
                                            <div class="user-block"> 
                                                <span class="text-lg">{apidata.data.ortu.dt_ayah.nm}
                                                </span>
                                                <div class="description overflow">
                                                    <b>
                                                        {apidata.data.ortu.dt_ayah.nik}
                                                    </b>
                                                    <br>
                                                    {apidata.data.ortu.dt_ayah.ttl}
                                                    <br>
                                                    {apidata.data.ortu.dt_ayah.almt} RT.{apidata.data.ortu.dt_ayah.rt} RW.{apidata.data.ortu.dt_ayah.rw}
                                                </div>
                                            </div>
                                            <!-- /.user-block -->
                                            <div class="box-tools">
                                                <span onclick="openModal('sipade','ktp/{apidata.data.ortu.dt_ayah.nik}','RakIT_Modal','ktp')"
                                                     class="btn-box-tool" data-toggle="tooltip"
                                                    data-placement="bottom" data-original-title="Pelayanan">
                                                    <i class="glyphicon glyphicon-send"></i>
                                                </span>
                                                <a href="#/sipade/kk/{apidata.data.ortu.dt_ayah.nokk}" class="btn-box-tool" data-toggle="tooltip"
                                                    data-placement="bottom" title="" data-original-title="Detail Keluarga">
                                                    <i class="glyphicon glyphicon-modal-window"></i>
                                                </a>
                                            </div>
                                            <!-- /.box-tools -->
                                        </div>
                                        <div class="box-footer text-right">
                                            <span onclick="openModal('sipade','cek/nik_edit/{apidata.data.ortu.dt_ayah.nik}','RakIT_Modal_Input','pen_edit')"
                                                 class="waves-effect pull-left" data-toggle="tooltip"
                                                data-placement="right" title="" data-original-title="Mutasi Data">
                                                <b class="glyphicon glyphicon-edit"></b>
                                            </span>
                                            <span class="badge sts{apidata.data.ortu.dt_ayah.jns}" data-toggle="tooltip" data-placement="top"
                                                title="" data-original-title="{apidata.data.ortu.dt_ayah.label} - {apidata.data.ortu.dt_ayah.td}"
                                                style="font-weight: 400;">
                                                <i class="glyphicon glyphicon-tag">
                                                </i>
                                                {apidata.data.ortu.dt_ayah.st}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {:else}
                            <tr>
                                <td colspan="3">
                                    <b>Nama Ayah : {apidata.data.ortu.dt_ayah.nm}</b>
                                    <div class="alert alert-warning">
                                        Data
                                        <b>
                                            Ayah
                                        </b>
                                        tidak terverifikasi, sistem menyarankan agar anda menghubungi petugas desa untuk melengkapi
                                        <b>
                                            data Ayah
                                        </b>
                                        terlebih dahulu. 
                                    </div>
                                </td>
                            </tr>
                            {/if} {#if apidata.data.ortu.ibu}
                            <tr>
                                <td colspan="3">
                                    <b class="float-right px-2 rounded-full bg-green-500 text-white">
                                        IBU
                                    </b>
                                    <div class="box box-widget">
                                        <div class="box-header with-border">
                                            <div class="user-block"> 
                                                <span class="text-lg">{apidata.data.ortu.dt_ibu.nm}
                                                </span>
                                                <div class="description overflow">
                                                    <b>
                                                        {apidata.data.ortu.dt_ibu.nik}
                                                    </b>
                                                    <br>
                                                    {apidata.data.ortu.dt_ibu.ttl}
                                                    <br>
                                                    {apidata.data.ortu.dt_ibu.almt} RT.{apidata.data.ortu.dt_ibu.rt} RW.{apidata.data.ortu.dt_ibu.rw}
                                                </div>
                                            </div>
                                            <!-- /.user-block -->
                                            <div class="box-tools">
                                                <span onclick="openModal('sipade','ktp/{apidata.data.ortu.dt_ibu.nik}','RakIT_Modal','ktp')"
                                                     class="btn-box-tool" data-toggle="tooltip"
                                                    data-placement="bottom" data-original-title="Pelayanan">
                                                    <i class="glyphicon glyphicon-send"></i>
                                                </span>
                                                <a href="#/sipade/kk/{apidata.data.ortu.dt_ibu.nokk}" class="btn-box-tool" data-toggle="tooltip"
                                                    data-placement="bottom" title="" data-original-title="Detail Keluarga">
                                                    <i class="glyphicon glyphicon-modal-window"></i>
                                                </a>
                                            </div>
                                            <!-- /.box-tools -->
                                        </div>
                                        <div class="box-footer text-right">
                                            <span onclick="openModal('sipade','cek/nik_edit/{apidata.data.ortu.dt_ibu.nik}','RakIT_Modal_Input','pen_edit')"
                                                 class="waves-effect pull-left" data-toggle="tooltip"
                                                data-placement="right" title="" data-original-title="Mutasi Data">
                                                <b class="glyphicon glyphicon-edit"></b>
                                            </span>
                                            <span class="badge sts{apidata.data.ortu.dt_ibu.jns}" data-toggle="tooltip" data-placement="top"
                                                title="" data-original-title="{apidata.data.ortu.dt_ibu.label} - {apidata.data.ortu.dt_ibu.td}"
                                                style="font-weight: 400;">
                                                <i class="glyphicon glyphicon-tag">
                                                </i>
                                                {apidata.data.ortu.dt_ibu.st}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {:else}
                            <tr>
                                <td colspan="3">
                                    <b>Nama Ibu : {apidata.data.ortu.dt_ibu.nm}</b>
                                    <div class="alert alert-warning">
                                        Data
                                        <b>
                                            Ibu
                                        </b>
                                        tidak terverifikasi, sistem menyarankan agar anda menghubungi petugas desa untuk melengkapi
                                        <b>
                                            data Ibu
                                        </b>
                                        terlebih dahulu. 
                                    </div>
                                </td>
                            </tr>
                            {/if}
                        <tr>
                            <td class="labelform text-right anakke dari">Anak Ke</td>
                            <td class="labelform" width="0">:</td>
                            <td data-title="Anak Ke/Dari">
                                <input type="number" name="anakke" bind:value={agemin}
                                    pattern="[0-9]*" inputmode="numeric" class="form-input lg:w-1/6 w-2/5  m-b-5" maxlength="2" min="1" placeholder="Anak Ke">
                                <span class="labelform"> / </span>
                                <input name="dari" type="number" pattern="[0-9]*"
                                    inputmode="numeric" class="form-input lg:w-1/6 w-2/5  m-b-5" maxlength="2" min={agemin} placeholder="Dari">
                            </td>
                        </tr>
                
                        <tr>
                            <td class="labelform text-right jamlhr menitlhr">Jam Lahir</td>
                            <td class="labelform" width="0">:</td>
                            <td data-title="Jam Lahir">
                                <input type="time" name="jamlhr" class="form-input lg:w-1/6 w-2/5  m-b-5" placeholder="Jam Lahir">
                            </td>
                        </tr>
                
                    </tbody>
                </table>

                {/if}